var _path, _rect, _path2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBitcoin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 220.001,
    height: 31.004,
    viewBox: "0 0 220.001 31.004",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard"
  }, /*#__PURE__*/React.createElement("g", {
    id: "BCE-Copy"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5-Copy"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M34.3,0h9.6a.838.838,0,0,1,.856.856v9.6H34.3Z",
    transform: "translate(-13.325 0)",
    fill: "#fff",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    width: 10.457,
    height: 10.457,
    transform: "translate(20.975 10.457)",
    fill: "#fff",
    opacity: 0.5,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    "data-name": "Path",
    d: "M34.3,34.2H44.757v9.295a.826.826,0,0,1-.856.795H34.3Z",
    transform: "translate(-13.325 -13.286)",
    fill: "#fff",
    fillRule: "evenodd",
    opacity: 0.25,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-3",
    "data-name": "Path",
    d: "M.856,0h9.662V10.457H0V.856A.838.838,0,0,1,.856,0Z",
    transform: "translate(0 0)",
    fill: "#fff",
    fillRule: "evenodd",
    opacity: 0.25,
    style: {
      isolation: "isolate"
    }
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    "data-name": "Rectangle",
    width: 10.457,
    height: 10.457,
    transform: "translate(10.457 10.457)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path-4",
    "data-name": "Path",
    d: "M0,34.2H10.457V44.29H.856A.826.826,0,0,1,0,43.495Z",
    transform: "translate(0 -13.286)",
    fill: "#fff",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-3",
    "data-name": "Rectangle",
    width: 10.457,
    height: 10.09,
    transform: "translate(10.457 20.914)",
    fill: "#fff",
    opacity: 0.5,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-4",
    "data-name": "Rectangle",
    width: 10.457,
    height: 10.457,
    transform: "translate(10.457 0)",
    fill: "#fff",
    opacity: 0.5,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-5",
    "data-name": "Rectangle",
    width: 10.457,
    height: 10.457,
    transform: "translate(0 10.457)",
    fill: "#fff",
    opacity: 0.5,
    style: {
      isolation: "isolate"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group-4-Copy",
    transform: "translate(38.873 2.36)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M75.127,29.482H63.875a.287.287,0,0,1-.306-.306l.122-12.536L63.57,4.165a.287.287,0,0,1,.306-.306H75c5.259,0,9.173,1.9,9.173,6.36,0,3.058-1.651,4.831-4.464,5.687,3.486.795,5.137,3.058,5.137,5.87C84.85,27.28,80.08,29.482,75.127,29.482ZM69.134,14.194h5.932c2.2,0,3.486-1.1,3.486-3.18,0-2.263-1.59-3.241-3.486-3.241H69.2ZM69.2,25.568H75c2.324,0,4.158-.856,4.158-3.852,0-2.691-1.9-3.669-4.158-3.669h-5.87Z",
    transform: "translate(-63.569 -3.859)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    "data-name": "Shape",
    d: "M100.375,8.837a.287.287,0,0,1-.306-.306V4.165a.287.287,0,0,1,.306-.306h5.155a.287.287,0,0,1,.306.306V8.507a.287.287,0,0,1-.306.306Zm0,20.669a.287.287,0,0,1-.306-.306l.061-9.111-.061-9.173a.287.287,0,0,1,.306-.306h5.155a.287.287,0,0,1,.306.306l-.061,9.173.061,9.111a.287.287,0,0,1-.306.306Z",
    transform: "translate(-77.749 -3.859)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-5",
    "data-name": "Path",
    d: "M123.544,30.03a.459.459,0,0,1-.306.428,11.007,11.007,0,0,1-3.486.612c-3.18,0-6.237-1.59-6.237-5.87l.061-9.478h-2.2a.4.4,0,0,1-.306-.245v-3.3a.287.287,0,0,1,.306-.306h2.2l-.061-4.4a.287.287,0,0,1,.306-.306h4.953a.287.287,0,0,1,.306.306l-.061,4.4H123.3a.287.287,0,0,1,.306.306v3.3a.287.287,0,0,1-.306.306h-4.281l.061,9.295c0,1.59.856,2.14,2.018,2.14a9.093,9.093,0,0,0,2.2-.306.226.226,0,0,1,.183.061c.061.061.122.122.122.183V30.03Z",
    transform: "translate(-82.023 -5.141)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-6",
    "data-name": "Path",
    d: "M141.293,34.234c-6.115,0-9.723-3.852-9.723-9.906s3.608-9.967,9.845-9.967c4.892,0,8.072,2.752,8.5,6.91a.214.214,0,0,1-.245.245h-4.586a.287.287,0,0,1-.306-.306c-.428-2.14-1.773-3.18-3.363-3.18-2.813.061-4.158,2.079-4.158,6.237,0,4.342,1.345,6.176,4.158,6.237,1.9.061,3.3-1.284,3.486-3.791a.33.33,0,0,1,.306-.306h4.709c.061,0,.122.061.183.061a.226.226,0,0,1,.061.183C149.793,31.115,146.246,34.234,141.293,34.234Z",
    transform: "translate(-89.987 -7.939)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-3",
    "data-name": "Shape",
    d: "M172.354,34.234c-6.237,0-9.784-3.852-9.784-9.906s3.608-9.967,9.845-9.967,9.784,3.852,9.784,9.906S178.591,34.234,172.354,34.234Zm0-3.669c2.752,0,4.036-1.9,4.036-6.176s-1.345-6.3-4.1-6.3-4.1,2.079-4.1,6.36S169.6,30.565,172.354,30.565Z",
    transform: "translate(-102.031 -7.939)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-4",
    "data-name": "Shape",
    d: "M196.575,9.313a.287.287,0,0,1-.306-.306V4.665a.287.287,0,0,1,.306-.306h5.137a.287.287,0,0,1,.306.306V9.031a.287.287,0,0,1-.306.306Zm0,20.669a.287.287,0,0,1-.306-.306l.061-9.111-.061-9.173a.287.287,0,0,1,.306-.306h5.137a.287.287,0,0,1,.306.306l-.061,9.173.061,9.111a.287.287,0,0,1-.306.306Z",
    transform: "translate(-115.123 -4.053)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-7",
    "data-name": "Path",
    d: "M208.175,33.828a.287.287,0,0,1-.306-.306l.061-8.867v-9.6a.287.287,0,0,1,.306-.306h4.77a.287.287,0,0,1,.306.306l-.122,2.079a7.827,7.827,0,0,1,6.176-2.874c4.036,0,6.665,2.752,6.665,7.4v3.975l.061,7.827a.287.287,0,0,1-.306.306h-5a.287.287,0,0,1-.306-.306l.061-7.827V21.72c0-2.079-1.223-3.424-2.874-3.424-2.018,0-4.158,1.835-4.158,5.932v1.406l.061,7.827a.287.287,0,0,1-.306.306h-5.075Z",
    transform: "translate(-119.629 -7.899)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-8",
    "data-name": "Path",
    d: "M239.075,42.856a.287.287,0,0,1-.306-.306V37.805a.287.287,0,0,1,.306-.306h5.137a.287.287,0,0,1,.306.306v4.77a.287.287,0,0,1-.306.306Z",
    transform: "translate(-131.634 -16.928)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-9",
    "data-name": "Path",
    d: "M258.493,34.234c-6.115,0-9.723-3.852-9.723-9.906s3.608-9.967,9.845-9.967c4.892,0,8.072,2.752,8.5,6.91a.214.214,0,0,1-.245.245h-4.507a.287.287,0,0,1-.306-.306c-.428-2.14-1.773-3.18-3.363-3.18-2.813.061-4.158,2.079-4.158,6.237,0,4.342,1.345,6.176,4.158,6.237,1.9.061,3.3-1.284,3.486-3.791a.33.33,0,0,1,.306-.306h4.647c.061,0,.122.061.183.061a.226.226,0,0,1,.061.183C266.993,31.115,263.507,34.234,258.493,34.234Z",
    transform: "translate(-135.519 -7.939)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-5",
    "data-name": "Shape",
    d: "M290.115,34.234c-6.237,0-9.845-3.852-9.845-9.906s3.608-9.967,9.845-9.967,9.784,3.852,9.784,9.906S296.353,34.234,290.115,34.234Zm0-3.669c2.752,0,4.036-1.9,4.036-6.176s-1.345-6.3-4.1-6.3-4.1,2.079-4.1,6.36S287.3,30.565,290.115,30.565Z",
    transform: "translate(-147.757 -7.939)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-10",
    "data-name": "Path",
    d: "M319.057,26.978l.061,6.543a.287.287,0,0,1-.306.306h-5.137a.287.287,0,0,1-.306-.306l.061-6.543V15.054a.287.287,0,0,1,.306-.306h4.831a.287.287,0,0,1,.306.306l-.122,2.079a6.421,6.421,0,0,1,5.5-2.874c2.691,0,4.647,1.162,5.5,3.608,1.651-2.874,3.547-3.608,5.809-3.608,3.852,0,6.115,2.324,6.115,7.4v5.283l.061,6.543a.287.287,0,0,1-.306.306H336.38a.287.287,0,0,1-.306-.306l.061-6.543v-5.2c0-2.324-.917-3.424-2.446-3.424s-3.363,2.018-3.363,5.932v2.691l.061,6.543a.287.287,0,0,1-.306.306h-4.953a.287.287,0,0,1-.306-.306l.061-6.543v-5.2c0-2.324-.917-3.424-2.446-3.424s-3.363,2.018-3.363,5.932Z",
    transform: "translate(-160.616 -7.899)",
    fill: "#fff",
    fillRule: "evenodd"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBitcoin);
export default __webpack_public_path__ + "static/media/bitcoin.9f098c5659a86e5e854dd48ee0d5bee1.svg";
export { ForwardRef as ReactComponent };